// removed by extract-text-webpack-plugin
module.exports = {"HeroRecommendation":"HeroRecommendation__HeroRecommendation__VkGGm","heroInfo":"HeroRecommendation__heroInfo__2SfgX","recommendationLogo":"HeroRecommendation__recommendationLogo__oT_wI","recommendationBtns":"HeroRecommendation__recommendationBtns__3YIL7","recommendationBtn":"HeroRecommendation__recommendationBtn__21aS1","playLogo":"HeroRecommendation__playLogo__2hJhR","recommendationBtnLogo":"HeroRecommendation__recommendationBtnLogo__1qClV","recommendationSynopsis":"HeroRecommendation__recommendationSynopsis__1z0gD","releaseDate":"HeroRecommendation__releaseDate__OR0cA"};


//////////////////
// WEBPACK FOOTER
// ./src/components/HeroRecommendation/HeroRecommendation.scss
// module id = 444
// module chunks = 0